import { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useTheme, ThemeToggle } from '../theme';
import { makeAuthStyles, errText } from './authStyles';
import logo from '../paraguard-logo.png';

export default function LoginPage() {
  const { user, login } = useAuth();
  const { colors } = useTheme();
  const S = makeAuthStyles(colors);
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await login(username, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={S.page}>
      <form style={S.card} onSubmit={submit}>
        <div style={S.topBar}><ThemeToggle /></div>
        <img src={logo} alt="ParaGuard" style={{ display: 'block', width: 132, height: 'auto', margin: '2px auto 6px' }} />
        <div style={S.field}>
          <label style={S.label}>Username</label>
          <input style={S.input} value={username} onChange={e => setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off" required />
        </div>
        <div style={S.field}>
          <label style={S.label}>Password</label>
          <input style={S.input} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        <div style={S.error}>{error}</div>
        <button style={S.button} type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <Link to="/register" style={S.link}>Create an account</Link>
        <Link to="/forgot-password" style={S.link}>Forgot password?</Link>
      </form>
    </div>
  );
}
